<template>
  <div :class="$style['subnav-panel']" ref="rootDom" data-lenis-prevent>
    <UtilScrollBox :class="$style['scroll-box']">
      <div :class="$style['panel-inner']">
        <div :class="$style['assets-info']">
          <div :class="$style['assets-title']" class="flex items-center">
            <span :class="$style['title']">{{ $t("assets_panel.assets_overview") }}</span>&nbsp;
            <button :class="$style['icon-box']" @click="showAssets = !showAssets">
              <i :class="[$style['icon'], showAssets ? 'ueicon-eye' : 'ueicon-eye-off']"></i>
            </button>
          </div>
          <div :class="$style['assets']" class="flex">
            <div :class="$style['assets-num']">
              {{ showAssets ? `${activeValue === 'BTC' ? toThousands(decimalsNotAdd0(totalBtc,8)) : toThousands(decimalsNotAdd0(totalUsd,2))}` : "****" }}
            </div>
            <div :class="$style['assets-unit']">
              <div :class="$style['unit']">{{ activeValue }}</div>
              <div :class="$style['ic']"></div>

              <div :class="$style['coin-panel']">
                <UtilScrollBox :class="$style['scroll-box']">
                  <div :class="$style['panel-inner']">
                    <div :class="$style['coin-item']" @click="activeValue = 'BTC'" :data-select="activeValue === 'BTC'">
                      BTC
                    </div>
                    <div :class="$style['coin-item']" @click="activeValue = 'USDT'"
                         :data-select="activeValue === 'USDT'">USDT
                    </div>
                  </div>
                </UtilScrollBox>
              </div>
            </div>
          </div>
          <div :class="$style['assets-transform']">
            <span :class="$style['num']">{{
                showAssets ? `≈${toThousands(toDecimal(toEquivalentOther(totalUsd)))}` : "****"
              }}</span>&nbsp;
            <span :class="$style['unit']" class="uppercase"> {{ currency }}</span>
          </div>
        </div>
        <div v-if="userInfo.type != 3" :class="$style['assets-change']" class="grid grid-cols-2">
          <button :class="$style['btn']" class="flex flex-col items-center justify-center"
                  @click="toLink('/wallet/chargemoney')">
            <span :class="$style['icon']" class="ueicon-chong-bi"></span>
            <span :class="$style['text']">{{ $t("assets_panel.deposit") }}</span>
          </button>
          <button :class="$style['btn']" class="flex flex-col items-center justify-center"
                  @click="toLink('/wallet/withdrawmoney')">
            <span :class="$style['icon']" class="ueicon-ti-bi"></span>
            <span :class="$style['text']">{{ $t("assets_panel.withdraw") }}</span>
          </button>
        </div>
        <div v-else :class="$style['assets-change']" class="grid grid-cols-2">
          <button :class="$style['btn']" class="flex flex-col items-center justify-center"
                  @click="toLink('/walletConnect/chargemoney')">
            <span :class="$style['icon']" class="ueicon-chong-bi"></span>
            <span :class="$style['text']">{{ $t("assets_panel.deposit") }}</span>
          </button>
          <button :class="$style['btn']" class="flex flex-col items-center justify-center"
                  @click="toLink('/walletConnect/chargemoney')">
            <span :class="$style['icon']" class="ueicon-ti-bi"></span>
            <span :class="$style['text']">{{ $t("assets_panel.withdraw") }}</span>
          </button>
        </div>
        <div :class="$style['assets-nav']">
          <a
              v-for="(item, index) in assetsPanelNavList"
              :key="index"
              :class="$style['nav-item']"
              :href="mainSiteUrl(item.link)"
              target="_blank"
          >
            <div :class="$style['item-inner']" class="flex items-center">
              <i :class="[$style['item-icon'], item.icon]"></i>
              <span :class="$style['item-title']">{{ item.title }}</span>
            </div>
          </a>
        </div>
      </div>
    </UtilScrollBox>
  </div>
</template>
<script>
import UtilScrollBox from "./ScrollBox";
import {useLighterBorder} from '../../plugins/use-lighter-border'
import {mapGetters} from "vuex";
import {getWallet} from '@/apis/wallet'
import {toThousands, toDecimal,decimalsNotAdd0} from "../../plugins/methods";
import {getRateList} from "@/apis/user";
import urls from "@/utils/baseUrl";
import {buildMainSiteUrl} from '@/utils/navigate-nav-item'
export default {
  name: "AssetsPanel",
  components: {UtilScrollBox},
  data() {
    return {
      showAssets: true,
      cleanupLighterBorder: null,
      cleanupScrollTriggers: [],
      totalUsd: '',
      totalBtc: '',
      activeValue: 'BTC',
      assetsPanelNavList: [
        {icon: 'ueicon-qian-bao-zong-lan', title: this.$t('assets_panel.assets_overview'), link: '/consolidation/walletotal'},
        {icon: 'ueicon-xian-huo-zhang-hu', title: this.$t('assets_panel.spot_account'), link: '/consolidation/spot?tab=spot'},
        {icon: 'ueicon-he-yue-zhang-hu', title: this.$t('assets_panel.futures_account'), link: '/consolidation/contract'},
        {icon: 'ueicon-zi-you-qu-zhang-hu', title: this.$t('assets_panel.free_account'), link: '/consolidation/spot?tab=freeZone'},
        {icon: 'ueicon-amm-zhang-hu', title: this.$t('assets_panel.amm_account'), link: '/consolidation/spot?tab=amm'},
        {icon: 'ueicon-p2p-zhang-hu', title: this.$t('assets_panel.p2p_account'), link: '/consolidation/p2p'},
        {
          icon: 'ueicon-jin-rong-zhang-hu',
          title: this.$t('assets_panel.financial_account'),
          link: '/consolidation/finance'
        },
        {icon: 'ueicon-ce-lue-zhang-hu', title: this.$t('assets_panel.strategy_account'), link: '/consolidation/tradingBot'},
        {icon: 'ueicon-he-yue-zhang-hu', title: this.$t('assets_panel.7000397'), link: '/consolidation/contractDocumentary'},
        {icon: 'ueicon-ding-dan', title: this.$t('assets_panel.order'), link: '/consolidation/order/spot'},
        {icon: 'ueicon-qian-bao-li-shi', title: this.$t('assets_panel.wallet_history'), link: '/consolidation/history'},
      ],
      rateConfig: {},
      linkUrl: urls.linkUrl
    };
  },
  computed: {
    ...mapGetters(["userInfo", 'currency', 'language']),
  },
  mounted() {
    this.cleanupLighterBorder = useLighterBorder(
        this,
        this.$refs.rootDom
    );
  },
  created() {
    this.getList()
    this.getRateList()
  },
  methods: {
    getRateList() {
      getRateList().then(res => {
        var rateConfig = {}
        for (let i in res.data) {
          rateConfig[res.data[i]['currency']] = res.data[i]
        }
        this.rateConfig = rateConfig
      })
    },
    toThousands,
    decimalsNotAdd0,
    toEquivalentOther(val) {
      if (this.rateConfig[this.currency]) {
        return Number(val) * this.rateConfig[this.currency].rate
      }
    },
    toLink(link) {
      window.open(this.mainSiteUrl(link))
    },
    mainSiteUrl(link) {
      return buildMainSiteUrl(this.linkUrl, link, this.language)
    },
    toDecimal(num) {
      if (isNaN(num)) return '--'
      return toDecimal(num)
    },
    getList() {
      getWallet().then((res) => {
        if (res.code == 200) {
          this.totalUsd = res.data.totalUsd || 0
          this.totalBtc = res.data.totalBtc || 0
        }
      })
    },
  },
  beforeDestroy() {
    if (this.cleanupLighterBorder) {
      this.cleanupLighterBorder();
    }
    this.cleanupScrollTriggers.forEach(cleanupFn => cleanupFn());
  },
};
</script>
<style lang="scss" module>
@import "../../assets/css/scss-utils/scss/abstracts/_mixins";
@import "../../assets/css/scss-utils/scss/abstracts/_breakpoint";
@import "../../assets/css/variable";
@import "../../assets/css/mixin";
@import "../../assets/css/var";

:global(html[data-theme="sunlight"]) {
  .subnav-panel {
    border-color: rgba(0, 0, 0, 0.1);
    background-color: #fff;
    box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.1);

    .assets-nav {
      .nav-item {
        color: color(var(--font-color), 1);

        &:hover {
          color: color(var(--theme-color));
          background: #fafafa;
        }
      }
    }

    .assets-info {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);

      .assets {
        .assets-num {
          @include text-clip(
                  color(var(--theme-color)),
                  linear-gradient(91.25deg, #ff9100 11.08%, #ffca63 146.11%)
          );
        }

        .assets-unit {
          color: #ffb53f;
        }

        .coin-panel {
          border-radius: 8px;
          background: #fff;
          box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
}

.subnav-panel {
  --border-width: 1px;
  min-width: 222px;

  border: var(--border-width) solid rgba(#fff, 0.1);
  border-radius: 8px;
  background: #202020;
  box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.3);

  .scroll-box {
    max-height: max-content;
    padding: 14px;
  }

  .assets-info {
    margin-bottom: 16px;
    padding: 10px;
    padding-bottom: 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    .assets-title {
      margin-bottom: 12px;

      transition: var(--transition-theme-color);

      color: color(var(--font-color), 1);
    }

    .assets {
      font-size: 16px;
      font-weight: 600;
      line-height: em(16px, 16px);

      position: relative;
      z-index: 1;

      margin-bottom: 6px;

      letter-spacing: em(-0.32px, 16px);

      gap: 4px;

      .assets-num {
        @include text-clip(
                color(var(--theme-color)),
                linear-gradient(92.27deg, #ffefcd -21.16%, #ffca63 81.8%)
        );
        font-family: "Plus Jakarta Sans";
      }

      .assets-unit {
        position: relative;

        display: flex;

        color: color(var(--theme-color));

        gap: 4px;

        &:hover {
          .coin-panel {
            visibility: visible;

            opacity: 1;
          }
        }

        .unit {
          font-family: "Plus Jakarta Sans";
        }

        .ic {
          position: relative;

          display: block;

          width: 12px;

          background-image: url('data:image/svg+xml,<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.0894 4H2.49939C2.05939 4 1.82939 4.54 2.14939 4.85L5.93939 8.64C6.13939 8.84 6.44939 8.84 6.64939 8.64L10.4394 4.85C10.7494 4.53 10.5294 4 10.0894 4Z" fill="%23FFC72B"/></svg>');
          background-repeat: no-repeat;
          background-position: center center;
          background-size: contain;
        }
      }

      .coin-panel {
        --border-width: 1px;
        font-size: 14px;
        font-weight: 500;
        line-height: 160%; /* 22.4px */

        position: absolute;
        z-index: 100;
        top: calc(100% + 8px);
        left: 50%;

        visibility: hidden;

        min-width: 106px;
        padding: 14px 0;

        transition: var(--transition-theme-color);
        transform: translateX(-50%);

        opacity: 0;
        border: 1px solid color(var(--font-color), 0.1);
        border-radius: 8px;
        background: #202020;

        &::before {
          position: absolute;
          bottom: 100%;
          left: 0;

          width: 100%;
          height: 9px;

          content: "";
        }

        .scroll-box {
          max-height: max-content;
          padding: 0 14px;
        }

        .panel-inner {
          display: flex;
          flex-direction: column;

          gap: 16px;
        }
      }

      .coin-item {
        position: relative;
        z-index: 10;

        padding-right: 16px;

        cursor: pointer;
        transition: var(--transition-theme-color);

        color: color(var(--font-color));
        background-repeat: no-repeat;
        background-position: right center;
        background-size: 16px 16px;

        &:hover {
          color: color(var(--theme-color));
        }

        &[data-select="true"] {
          color: color(var(--theme-color));
          background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M13.6667 4L6.33333 11.3333L3 8" stroke="%23FFC72B" stroke-width="1.46667" stroke-linecap="round" stroke-linejoin="round"/></svg>');
        }
      }
    }

    .assets-transform {
      font-size: 12px;
      font-weight: 500;

      transition: var(--transition-theme-color);

      color: color(var(--font-color));
    }

    .title {
      font-size: 12px;
      font-weight: 500;
    }

    .icon-box,
    .icon {
      font-size: 14px;
      line-height: 1;
    }
  }

  .assets-change {
    font-size: 12px;
    font-weight: 500;
    line-height: em(17px, 12px);

    margin-bottom: 16px;

    gap: 11px;

    .btn {
      padding: 5px;

      transition: var(--transition-theme-color);

      border: 1px solid color(var(--font-color), 0.1);
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.1);

      gap: 2px;

      &:hover {
        color: #000;
        background-color: color(var(--theme-color));
      }
    }

    .icon {
      font-size: 16px;
    }
  }

  .assets-nav {
    display: grid;

    gap: 10px;

    .nav-item {
      font-size: 14px;
      font-weight: 500;
      line-height: em(28px, 14px);

      padding: 7px 12px;

      transition: var(--transition-theme-color);

      color: color(var(--font-color));
      border-radius: 6px;

      gap: 8px;

      .item-inner {
        gap: 8px;
      }

      .item-icon {
        font-size: em(18px, 14px);
      }

      &:hover {
        color: color(var(--theme-color));
        background: #282828;
      }
    }
  }
}

@include media-breakpoint-down(xl) {
  .subnav-panel {
    .assets-nav {
      .nav-item {
        font-size: 13px;
      }
    }
  }
}
</style>
